import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import './Prisma.css';
import { WordsPullUpMultiStyle, ScrollRevealText, Reveal, FadeUp } from './Animations';
import { FaGithub, FaLinkedin, FaLayerGroup, FaDatabase, FaProjectDiagram } from 'react-icons/fa';
import CustomCursor from './CustomCursor';
import ParticleBackground from './ParticleBackground';
import TypewriterText from './TypewriterText';
import Showcase from './Showcase';
import profileImage from './profile.png';

const languages = [
  { id: 'pt', code: 'BR', label: 'Português' },
  { id: 'en', code: 'EN', label: 'English' },
  { id: 'es', code: 'ES', label: 'Español' },
];

const countries = [
  { code: 'BR', name: 'Brasil', flag: '🇧🇷', dialCode: '55', maxLength: 11 },
  { code: 'US', name: 'Estados Unidos', flag: '🇺🇸', dialCode: '1', maxLength: 10 },
  { code: 'CA', name: 'Canadá', flag: '🇨🇦', dialCode: '1', maxLength: 10 },
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', dialCode: '54', maxLength: 10 },
  { code: 'CL', name: 'Chile', flag: '🇨🇱', dialCode: '56', maxLength: 9 },
  { code: 'CO', name: 'Colômbia', flag: '🇨🇴', dialCode: '57', maxLength: 10 },
  { code: 'MX', name: 'México', flag: '🇲🇽', dialCode: '52', maxLength: 10 },
  { code: 'PE', name: 'Peru', flag: '🇵🇪', dialCode: '51', maxLength: 9 },
  { code: 'UY', name: 'Uruguai', flag: '🇺🇾', dialCode: '598', maxLength: 8 },
  { code: 'GB', name: 'Reino Unido', flag: '🇬🇧', dialCode: '44', maxLength: 10 },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', dialCode: '351', maxLength: 9 },
  { code: 'ES', name: 'Espanha', flag: '🇪🇸', dialCode: '34', maxLength: 9 },
  { code: 'FR', name: 'França', flag: '🇫🇷', dialCode: '33', maxLength: 9 },
  { code: 'DE', name: 'Alemanha', flag: '🇩🇪', dialCode: '49', maxLength: 11 },
  { code: 'IT', name: 'Itália', flag: '🇮🇹', dialCode: '39', maxLength: 10 },
  { code: 'IE', name: 'Irlanda', flag: '🇮🇪', dialCode: '353', maxLength: 9 },
  { code: 'AU', name: 'Austrália', flag: '🇦🇺', dialCode: '61', maxLength: 9 },
  { code: 'NZ', name: 'Nova Zelândia', flag: '🇳🇿', dialCode: '64', maxLength: 9 },
  { code: 'ZA', name: 'África do Sul', flag: '🇿🇦', dialCode: '27', maxLength: 9 },
  { code: 'AO', name: 'Angola', flag: '🇦🇴', dialCode: '244', maxLength: 9 },
  { code: 'MZ', name: 'Moçambique', flag: '🇲🇿', dialCode: '258', maxLength: 9 },
  { code: 'JP', name: 'Japão', flag: '🇯🇵', dialCode: '81', maxLength: 10 },
  { code: 'CN', name: 'China', flag: '🇨🇳', dialCode: '86', maxLength: 11 },
  { code: 'IN', name: 'Índia', flag: '🇮🇳', dialCode: '91', maxLength: 10 },
  { code: 'AE', name: 'Emirados Árabes Unidos', flag: '🇦🇪', dialCode: '971', maxLength: 9 },
];

const defaultCountryByLanguage = { pt: 'BR', en: 'US', es: 'ES' };

const countryName = (country, language) => {
  try { return new Intl.DisplayNames([language], { type: 'region' }).of(country.code) || country.name; } catch (e) { return country.name; }
};

const formatPhoneNumber = (value, country) => {
  const digits = value.replace(/\D/g, '').slice(0, country.maxLength);
  if (country.code === 'BR') {
    if (digits.length <= 2) return digits;
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (country.code === 'US' || country.code === 'CA') {
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return digits.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
};
const brandRoles = {
  pt: "Desenvolvedor de Software",
  en: "Software Developer",
  es: "Desarrollador de Software",
};

const translations = {
  pt: {
    languageLabel: 'Português',
    photoAlt: 'Foto  de perfil',
    selectCountry: 'Selecionar país', countriesList: 'Países disponíveis', phonePlaceholder: 'Número de telefone', codeWord: 'código',
    home: 'Início', about: 'Sobre', projects: 'Projetos', skills: 'Habilidades', contact: 'Contato',
    headline: 'Olá, eu sou Josué Matos',
    subtitle: 'Desenvolvedor focado em criar soluções digitais funcionais e experiências que geram resultados.',
    contactButton: 'Entre em Contato', workButton: 'Ver Meu Trabalho',
    aboutTitle: 'Sobre Mim',
    aboutText:
      'Minha relação com a tecnologia começou cedo, aos 5 anos, quando comecei a ter contato com computadores e a descobrir, aos poucos, tudo o que era possível fazer com eles. Desde então, a tecnologia sempre esteve presente na minha vida e, com o passar dos anos, esse interesse foi se tornando cada vez maior.\n\n' +
      'Há cerca de 3 anos, comecei de fato minha jornada na programação, passando a estudar desenvolvimento de software e transformar minha curiosidade em projetos reais. Hoje, aos 22 anos, sou formado em Análise e Desenvolvimento de Sistemas e venho construindo minha experiência no desenvolvimento de aplicações, atuando tanto no Front-end quanto no Back-end.\n\n' +
      'Durante esse caminho, tive a oportunidade de trabalhar em projetos envolvendo integrações, APIs, bancos de dados, automações e diferentes sistemas. Mais recentemente, também comecei a explorar soluções com inteligência artificial, criando projetos que unem desenvolvimento de software, automação e IA.\n\n' +
      'Ainda considero minha jornada apenas o começo. Gosto de aprender colocando a mão no código, entender como as coisas funcionam e, principalmente, transformar problemas e ideias em soluções.',
    servicesEyebrow: 'No que posso ajudar?',
    service1: 'Landing Pages', service2: 'Desenvolvimento Web', service3: 'Agente de IA', service4: 'Web Design',
    skillsEyebrow: 'Habilidades & Especialidades',
    skillsTitle: 'Stack principal e forma de atuação',
    skillsSubtitle: 'Aqui estão algumas das tecnologias e ferramentas com as quais trabalho regularmente.',
    skill1Title: 'Desenvolvimento Web', skill1Tags: 'React, TypeScript, Node.js, HTML, CSS',
    skill2Title: 'Back-end & Banco de Dados', skill2Tags: 'Node.js, C#, PostgreSQL, MySQL, APIs REST',
    skill3Title: 'Automação & IA', skill3Tags: 'n8n, Agentes LLM, MCP, Integrações, Webhooks',
    contactEyebrow: 'Contato',
    contactHeadline: 'Se meu perfil faz sentido para a sua necessidade, vamos conversar.',
    contactLinkedinNote: 'LinkedIn é o melhor caminho para iniciar a conversa; no GitHub, você pode revisar projetos e exemplos reais de implementação.',
    formTitle: 'Envie uma mensagem',
    formSubtitle: 'Conte o que você precisa e eu retorno em breve.',
    formName: 'Nome', formEmail: 'E-mail', formPhone: 'Telefone', formMessage: 'Mensagem',
    formSubmit: 'Enviar pelo WhatsApp',
    formSending: 'Abrindo WhatsApp...',
    formSuccess: 'WhatsApp aberto! Clique em enviar para concluir o envio.',
    formError: 'Não foi possível abrir o WhatsApp. Tente novamente.',
    projectSectionTitle: 'Projetos',
    projectsIntro: 'Aqui estão alguns dos projetos que desenvolvi durante minha jornada na programação, explorando diferentes desafios e colocando meus conhecimentos em prática.',
    projectsPanelTitle: 'O que eu faço',
    projectsPanelSubtitle: 'Conheça alguns dos projetos e soluções que desenvolvi ao longo da minha jornada.',
    statYears: '3+', statYearsLabel: 'anos de jornada',
    statProjects: '3+', statProjectsLabel: 'projetos desenvolvidos',
    statFocus: 'FS', statFocusLabel: 'Front-end e Back-end',
    projectsGithubCta: 'Ver perfil no GitHub',
    viewOnGithub: 'Ver no GitHub',
    project1Title: 'Automação e IA para Negócios',
    project1Responsibilities: 'Automação completa de atendimento via WhatsApp com agentes LLM. O sistema interpreta mensagens dos clientes, consulta disponibilidade de passeios em tempo real, gera links de pagamento e confirma reservas automaticamente — sem intervenção humanaDesenvolvimento de automações que conectam diferentes sistemas e serviços, tornando tarefas do dia a dia mais rápidas e eficientes. Criação de soluções que podem organizar informações, automatizar atendimentos, enviar notificações, integrar ferramentas e executar tarefas automaticamente, reduzindo trabalhos repetitivos e permitindo que sua empresa ganhe mais tempo e produtividade..',
    project2Title: 'Desenvolvimento Web',
    project2Problem: 'Criação de aplicações web modernas com React, TypeScript e Node.js, incluindo interfaces responsivas, integrações com APIs e Back-end, autenticação e boas práticas de desenvolvimento.',
  },
  en: {
    languageLabel: 'English',
    photoAlt: 'Profile photo',
    selectCountry: 'Select country', countriesList: 'Available countries', phonePlaceholder: 'Phone number', codeWord: 'code',
    home: 'Home', about: 'About', projects: 'Projects', skills: 'Skills', contact: 'Contact',
    headline: 'Hello, I am Josué Matos',
    subtitle: 'A developer focused on creating functional digital solutions and experiences that deliver results.',
    contactButton: 'Contact Me', workButton: 'See My Work',
    aboutTitle: 'About Me',
    aboutText:
      'My relationship with technology started early — at 5 years old, I began exploring computers and discovering, little by little, everything it was possible to do with them. Since then, technology has always been part of my life, and over the years that interest has only grown.\n\n' +
      'About 3 years ago, I truly began my programming journey, studying software development and turning my curiosity into real projects. Today, at 22, I hold a degree in Systems Analysis and Development and have been building my experience in application development, working on both Front-end and Back-end.\n\n' +
      'Along the way, I had the opportunity to work on projects involving integrations, APIs, databases, automations, and different systems. More recently, I also started exploring artificial intelligence solutions, creating projects that combine software development, automation, and AI.\n\n' +
      'I still consider my journey just the beginning. I enjoy learning by writing code, understanding how things work, and — above all — turning problems and ideas into solutions.',
    servicesEyebrow: 'What I can help with',
    service1: 'Landing Pages', service2: 'Web Development', service3: 'AI Agent', service4: 'Web Design',
    skillsEyebrow: 'Skills & Specialties',
    skillsTitle: 'Main stack and how I work',
    skillsSubtitle: 'Here are some of the technologies and tools I work with regularly.',
    skill1Title: 'Web Development', skill1Tags: 'React, TypeScript, Node.js, HTML, CSS',
    skill2Title: 'Back-end & Databases', skill2Tags: 'Node.js, C#, PostgreSQL, MySQL, REST APIs',
    skill3Title: 'Automation & AI', skill3Tags: 'n8n, LLM Agents, MCP, Integrations, Webhooks',
    contactEyebrow: 'Contact',
    contactHeadline: 'If my profile fits your needs, let\'s talk.',
    contactLinkedinNote: 'LinkedIn is the best way to start the conversation; on GitHub, you can review real projects and implementation examples.',
    formTitle: 'Send a message',
    formSubtitle: 'Tell me what you need and I\'ll get back to you shortly.',
    formName: 'Name', formEmail: 'E-mail', formPhone: 'Phone', formMessage: 'Message',
    formSubmit: 'Send via WhatsApp',
    formSending: 'Opening WhatsApp...',
    formSuccess: 'WhatsApp opened! Click send to complete the delivery.',
    formError: 'Could not open WhatsApp. Please try again.',
    projectSectionTitle: 'Projects',
    projectsIntro: 'Here are some of the projects I developed during my programming journey, exploring different challenges and putting my knowledge into practice.',
    projectsPanelTitle: 'What I do',
    projectsPanelSubtitle: 'Here are some of the projects and solutions I developed along my journey.',
    statYears: '3+', statYearsLabel: 'years of journey',
    statProjects: '3+', statProjectsLabel: 'projects developed',
    statFocus: 'FS', statFocusLabel: 'Front-end & Back-end',
    projectsGithubCta: 'View GitHub profile',
    viewOnGithub: 'View on GitHub',
    project1Title: 'AI Attendance Agent — Travel Agency',
    project1Responsibilities: 'Full WhatsApp attendance automation using LLM agents. The system interprets customer messages, checks tour availability in real time, generates payment links, and confirms bookings automatically — with no human intervention.',
    project2Title: 'Web Development',
    project2Problem: 'Building modern web applications with React, TypeScript, and Node.js, including responsive interfaces, API and Back-end integrations, authentication, and development best practices.',
  },
  es: {
    languageLabel: 'Español',
    photoAlt: 'Foto de perfil',
    selectCountry: 'Seleccionar país', countriesList: 'Países disponibles', phonePlaceholder: 'Número de teléfono', codeWord: 'código',
    home: 'Inicio', about: 'Sobre mí', projects: 'Proyectos', skills: 'Habilidades', contact: 'Contacto',
    headline: 'Hola, soy Josué Matos',
    subtitle: 'Un desarrollador enfocado en crear soluciones digitales funcionales y experiencias que generan resultados.',
    contactButton: 'Contáctame', workButton: 'Ver mi trabajo',
    aboutTitle: 'Sobre mí',
    aboutText:
      'Mi relación con la tecnología comenzó temprano — a los 5 años empecé a tener contacto con computadoras y a descubrir, poco a poco, todo lo que era posible hacer con ellas. Desde entonces, la tecnología siempre estuvo presente en mi vida y, con el paso de los años, ese interés fue creciendo cada vez más.\n\n' +
      'Hace unos 3 años, comencé de verdad mi camino en la programación, estudiando desarrollo de software y transformando mi curiosidad en proyectos reales. Hoy, a los 22 años, tengo formación en Análisis y Desarrollo de Sistemas y vengo construyendo mi experiencia en el desarrollo de aplicaciones, trabajando tanto en Front-end como en Back-end.\n\n' +
      'Durante este camino, tuve la oportunidad de trabajar en proyectos que involucran integraciones, APIs, bases de datos, automatizaciones y diferentes sistemas. Más recientemente, también comencé a explorar soluciones con inteligencia artificial, creando proyectos que combinan desarrollo de software, automatización e IA.\n\n' +
      'Aún considero que mi camino apenas comienza. Me gusta aprender escribiendo código, entender cómo funcionan las cosas y, principalmente, transformar problemas e ideas en soluciones.',
    servicesEyebrow: 'En qué puedo ayudar',
    service1: 'Landing Pages', service2: 'Desarrollo Web', service3: 'Agente de IA', service4: 'Diseño Web',
    skillsEyebrow: 'Habilidades & Especialidades',
    skillsTitle: 'Stack principal y forma de trabajo',
    skillsSubtitle: 'Aquí están algunas de las tecnologías y herramientas con las que trabajo regularmente.',
    skill1Title: 'Desarrollo Web', skill1Tags: 'React, TypeScript, Node.js, HTML, CSS',
    skill2Title: 'Back-end & Bases de Datos', skill2Tags: 'Node.js, C#, PostgreSQL, MySQL, APIs REST',
    skill3Title: 'Automatización & IA', skill3Tags: 'n8n, Agentes LLM, MCP, Integraciones, Webhooks',
    contactEyebrow: 'Contacto',
    contactHeadline: 'Si mi perfil encaja con tu necesidad, hablemos.',
    contactLinkedinNote: 'LinkedIn es el mejor camino para iniciar la conversación; en GitHub puedes revisar proyectos y ejemplos reales de implementación.',
    formTitle: 'Envía un mensaje',
    formSubtitle: 'Cuéntame qué necesitas y te respondo pronto.',
    formName: 'Nombre', formEmail: 'E-mail', formPhone: 'Teléfono', formMessage: 'Mensaje',
    formSubmit: 'Enviar por WhatsApp',
    formSending: 'Abriendo WhatsApp...',
    formSuccess: '¡WhatsApp abierto! Haz clic en enviar para completar el envío.',
    formError: 'No fue posible abrir WhatsApp. Inténtalo de nuevo.',
    projectSectionTitle: 'Proyectos',
    projectsIntro: 'Aquí están algunos de los proyectos que desarrollé durante mi camino en la programación, explorando diferentes desafíos y poniendo mis conocimientos en práctica.',
    projectsPanelTitle: 'Lo que hago',
    projectsPanelSubtitle: 'Conoce algunos de los proyectos y soluciones que desarrollé a lo largo de mi camino.',
    statYears: '3+', statYearsLabel: 'años de camino',
    statProjects: '3+', statProjectsLabel: 'proyectos desarrollados',
    statFocus: 'FS', statFocusLabel: 'Front-end y Back-end',
    projectsGithubCta: 'Ver perfil en GitHub',
    viewOnGithub: 'Ver en GitHub',
    project1Title: 'Agente de Atención — Agencia de Viajes',
    project1Responsibilities: 'Automatización completa de atención por WhatsApp con agentes LLM. El sistema interpreta los mensajes de los clientes, consulta disponibilidad de tours en tiempo real, genera enlaces de pago y confirma reservas automáticamente, sin intervención humana.',
    project2Title: 'Desarrollo Web',
    project2Problem: 'Creación de aplicaciones web modernas con React, TypeScript y Node.js, incluyendo interfaces responsivas, integraciones con APIs y Back-end, autenticación y buenas prácticas de desarrollo.',
  },
};

function ContactForm({ t, language }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [country, setCountry] = useState(countries[0]);
  const [countryMenuOpen, setCountryMenuOpen] = useState(false);
  const countrySelectorRef = useRef(null);
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const next = countries.find((c) => c.code === defaultCountryByLanguage[language]);
    if (!next) return;
    setCountry(next);
    setForm((current) => ({ ...current, phone: formatPhoneNumber(current.phone, next) }));
  }, [language]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  useEffect(() => {
    if (!countryMenuOpen) return undefined;
    const closeMenu = (event) => {
      if (countrySelectorRef.current && !countrySelectorRef.current.contains(event.target)) setCountryMenuOpen(false);
    };
    const closeOnEscape = (event) => { if (event.key === 'Escape') setCountryMenuOpen(false); };
    document.addEventListener('mousedown', closeMenu);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('mousedown', closeMenu);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [countryMenuOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setSent(false);
    setError(false);

    const whatsappMessage = [
      'Olá! você Recebeu uma mensagem pelo seu portfólio.',
      '',
      `Nome: ${form.name}`,
      `E-mail: ${form.email}`,
      `Telefone: +${country.dialCode} ${form.phone}`,
      '',
      'Mensagem:',
      form.message,
    ].join('\n');
    const whatsappUrl = `https://wa.me/5585987930554?text=${encodeURIComponent(whatsappMessage)}`;

    try {
      window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
      setSent(true);
      setForm({ name: '', email: '', phone: '', message: '' });
      setTimeout(() => setSent(false), 5000);
    } catch (err) {
      setError(true);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-form-card">
      <h3 className="form-card-title">{t.formTitle}</h3>
      <p className="form-card-subtitle">{t.formSubtitle}</p>
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">{t.formName}</label>
            <input
              className="form-input"
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label className="form-label">{t.formEmail}</label>
            <input
              className="form-input"
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="phone">{t.formPhone}</label>
          <div className="phone-input-wrap">
            <div className="country-selector" ref={countrySelectorRef}>
              <button className="country-selector__trigger" type="button" aria-haspopup="listbox" aria-expanded={countryMenuOpen} aria-label={`${t.selectCountry}. ${countryName(country, language)}, ${t.codeWord} +${country.dialCode}`} onClick={() => setCountryMenuOpen((open) => !open)}>
                <img className="country-selector__flag" src={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png`} alt="" />
                <span className="country-selector__code">+{country.dialCode}</span>
                <span className="country-selector__chevron" aria-hidden="true">⌄</span>
              </button>
              {countryMenuOpen && (
                <ul className="country-selector__menu" role="listbox" aria-label={t.countriesList}>
                  {countries.map((item) => (
                    <li key={item.code}>
                      <button className={`country-selector__option ${item.code === country.code ? 'is-selected' : ''}`} type="button" role="option" aria-selected={item.code === country.code} onClick={() => { setCountry(item); setForm((current) => ({ ...current, phone: formatPhoneNumber(current.phone, item) })); setCountryMenuOpen(false); }}>
                        <img className="country-selector__flag" src={`https://flagcdn.com/w40/${item.code.toLowerCase()}.png`} alt="" loading="lazy" />
                        <span className="country-selector__name">{countryName(item, language)}</span>
                        <span className="country-selector__option-code">+{item.dialCode}</span>
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <input
              id="phone"
              className="form-input phone-input"
              type="tel"
              name="phone"
              value={form.phone}
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, '');
                setForm((current) => ({ ...current, phone: formatPhoneNumber(digits, country) }));
              }}
              required
              inputMode="numeric"
              autoComplete="tel-national"
              placeholder={country.code === 'BR' ? '(00) 00000-0000' : t.phonePlaceholder}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">{t.formMessage}</label>
          <textarea
            className="form-input form-textarea"
            name="message"
            value={form.message}
            onChange={handleChange}
            rows={5}
            required
          />
        </div>
        {sent && <p className="form-success">{t.formSuccess}</p>}
        {error && <p className="form-error">{t.formError}</p>}
        <button className="form-submit" type="submit" disabled={sending}>
          {sending ? t.formSending : t.formSubmit}
        </button>
      </form>
    </div>
  );
}

function App() {
  const [language, setLanguage] = useState('pt');
  const [langMenuOpen, setLangMenuOpen] = useState(false);
  const langSelectorRef = useRef(null);
  const t = translations[language];

  useEffect(() => {
    if (!langMenuOpen) return undefined;
    const handlePointerDown = (event) => {
      if (langSelectorRef.current && !langSelectorRef.current.contains(event.target)) setLangMenuOpen(false);
    };
    const handleKeyDown = (event) => { if (event.key === 'Escape') setLangMenuOpen(false); };
    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [langMenuOpen]);

  const serviceItems = [
    { title: t.service1, imageLeft: '/showcase/landing-1.jpg', imageRight: '/showcase/landing-2.png', scrollImage: '/showcase/landing-2.png' },
    { title: t.service2, imageLeft: '/showcase/dev-1.jpg', imageRight: '/showcase/dev-2.png' },
    { title: t.service3, imageLeft: '/showcase/ai-1.jpg', imageRight: '/showcase/ai-2.jpg' },
    { title: t.service4, imageLeft: '/showcase/design-1.jpg', imageRight: '/showcase/design-2.jpg' },
  ];

  return (
    <div className="App dark">
      <CustomCursor />
      <ParticleBackground />
      <nav className="navbar">
        <ul>
          <li><a href="#home">{t.home}</a></li>
          <li><a href="#sobre">{t.about}</a></li>
          <li><a href="#projetos">{t.projects}</a></li>
          <li><a href="#habilidades">{t.skills}</a></li>
          <li><a href="#contato">{t.contact}</a></li>
        </ul>
        <div className="language-selector" ref={langSelectorRef}>
          <button className="language-selector__trigger" type="button" aria-haspopup="listbox" aria-expanded={langMenuOpen} aria-label={t.languageLabel} onClick={() => setLangMenuOpen((open) => !open)}>
            {languages.find((l) => l.id === language).code}
          </button>
          {langMenuOpen && (
            <ul className="language-selector__menu" role="listbox">
              {languages.map((lang) => (
                <li key={lang.id}>
                  <button className={`language-selector__option${lang.id === language ? " is-active" : ""}`} type="button" role="option" aria-selected={lang.id === language} onClick={() => { setLanguage(lang.id); setLangMenuOpen(false); }}>
                    <span className="language-selector__option-code">{lang.code}</span>
                    <span>{lang.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </nav>

      <section id="home" className="section apresentacao">
        <video className="hero-video" src="https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260405_170732_8a9ccda6-5cff-4628-b164-059c500a2b41.mp4" autoPlay loop muted playsInline />
        <div className="hero-noise" />
        <div className="hero-shade" />
        <div className="hero">
          <div className="hero-content">
            <h1><TypewriterText className="hero-typed" text="Josué Matos" /></h1>
            <FadeUp delay={0.5}><p className="hero-sub">{t.subtitle}</p></FadeUp>
            <FadeUp delay={0.7}>
            <div className="hero-actions">
              <a href="https://web.whatsapp.com/" className="btn btn-primary" target="_blank" rel="noopener noreferrer">{t.contactButton}</a>
              <a href="#projetos" className="btn btn-outline">{t.workButton}</a>
            </div>
            <div className="hero-socials">
              <a href="https://github.com/JosueAnalisysDeveloper" aria-label="GitHub"><FaGithub /></a>
              <a href="https://www.linkedin.com/in/josuematos01/" aria-label="LinkedIn"><FaLinkedin /></a>
            </div>
            </FadeUp>
          </div>
        </div>
      </section>

      <section id="sobre" className="section sobre">
        <div className="about-layout">
          <div className="about-photo">
            <img src={profileImage} alt={t.photoAlt} />
          </div>
          <div className="about-body">
        <p className="about-label">{t.aboutTitle}</p>
        <h2 className="about-heading">
          <WordsPullUpMultiStyle key={language} segments={[
            { text: t.headline + ',', className: '' },
            { text: brandRoles[language] + '.', className: 'serif' },
          ]} />
        </h2>
        <ScrollRevealText className="about-text" text={t.aboutText} />
          </div>
        </div>
      </section>

      <section id="projetos" className="section projetos">
        <div className="projects-layout">
          <div className="projects-intro">
            <p className="projects-kicker">{t.projectSectionTitle}</p>
            <p className="projects-intro-text">{t.projectsIntro}</p>
            <div className="projects-stats">
              <div className="projects-stat"><strong>{t.statYears}</strong><span>{t.statYearsLabel}</span></div>
              <div className="projects-stat"><strong>{t.statProjects}</strong><span>{t.statProjectsLabel}</span></div>
              <div className="projects-stat"><strong>{t.statFocus}</strong><span>{t.statFocusLabel}</span></div>
            </div>
            <div className="projects-intro-stack">
              <span className="badge">Javascript</span><span className="badge">Node.js</span>
              <span className="badge">TypeScript</span><span className="badge">C#</span>
              <span className="badge">MySQL</span><span className="badge">PostgreSQL</span>
            </div>
            <a href="https://github.com/JosueAnalisysDeveloper" className="btn btn-outline projects-intro-cta" target="_blank" rel="noopener noreferrer">{t.projectsGithubCta}</a>
          </div>
          <div className="projects-panel">
            <h2>{t.projectsPanelTitle}</h2>
            <p className="projects-panel-sub">{t.projectsPanelSubtitle}</p>
            <Reveal as="article" index={0} className="project-card">
              <div className="project-card-head"><span className="project-card-icon" aria-hidden="true"><FaProjectDiagram /></span><h3>{t.project1Title}</h3></div>
              <p>{t.project1Responsibilities}</p>
            </Reveal>
            <Reveal as="article" index={1} className="project-card">
              <div className="project-card-head"><span className="project-card-icon" aria-hidden="true"><FaLayerGroup /></span><h3>{t.project2Title}</h3></div>
              <p>{t.project2Problem}</p>
            </Reveal>

          </div>
        </div>
      </section>

      <section id="servicos" className="section skills-section services-section">
        <p className="skills-eyebrow">{t.servicesEyebrow}</p>
        <Showcase items={serviceItems} />
      </section>

      <section id="habilidades" className="section skills-section">
        <p className="skills-eyebrow">{t.skillsEyebrow}</p>
        <h2 className="skills-title">{t.skillsTitle}</h2>
        <p className="skills-subtitle">{t.skillsSubtitle}</p>
        <div className="skills-grid">
          <Reveal index={0} className="skill-card"><h3 className="skill-card-title">{t.skill1Title}</h3><p className="skill-card-tags">{t.skill1Tags}</p></Reveal>
          <Reveal index={1} className="skill-card"><h3 className="skill-card-title">{t.skill2Title}</h3><p className="skill-card-tags">{t.skill2Tags}</p></Reveal>
          <Reveal index={2} className="skill-card"><h3 className="skill-card-title">{t.skill3Title}</h3><p className="skill-card-tags">{t.skill3Tags}</p></Reveal>
        </div>
      </section>

      <section id="contato" className="section contact-section">
        <div className="contact-layout">
          <div className="contact-left">
            <p className="contact-eyebrow">{t.contactEyebrow}</p>
            <h2 className="contact-headline">{t.contactHeadline}</h2>
            <div className="contact-social-btns">
              <a href="https://www.linkedin.com/in/josuematos01/" className="contact-btn contact-btn-dark" target="_blank" rel="noopener noreferrer">
                <FaLinkedin /> LinkedIn
              </a>
              <a href="https://github.com/JosueAnalisysDeveloper" className="contact-btn contact-btn-outline" target="_blank" rel="noopener noreferrer">
                <FaGithub /> GitHub
              </a>
            </div>
            <p className="contact-note">{t.contactLinkedinNote}</p>
          </div>
          <div className="contact-right">
            <ContactForm t={t} language={language} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;